/**
 * Autonomics `resource_profile` (server-computed): when true, show Consumptions on mission/scenario
 * edit views and use profile-derived battery / clean-water thresholds in the instant task scheduler.
 * When false, hide that UI and use fixed default thresholds only (profiles still returned by API).
 */
export const FEATURE_AUTONOMICS_CONSUMABLES_AND_PROFILE_THRESHOLDS = true
